/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedReviewRouteImport } from './routes/_authenticated/review'
import { Route as AuthenticatedTeamRouteImport } from './routes/_authenticated/team'
import { Route as AuthenticatedTestRecordRouteImport } from './routes/_authenticated/test-record'
import { Route as AuthenticatedTestingRouteImport } from './routes/_authenticated/testing'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AuthenticatedCampaignsIndexRouteImport } from './routes/_authenticated/campaigns.index'
import { Route as AuthenticatedCampaignsCampaignIdRouteImport } from './routes/_authenticated/campaigns.$campaignId'
import { Route as AuthenticatedCampaignsNewRouteImport } from './routes/_authenticated/campaigns.new'
import { Route as AuthenticatedSellersSfRecordIdRouteImport } from './routes/_authenticated/sellers.$sfRecordId'
import { Route as AuthenticatedSettingsAgentPromptRouteImport } from './routes/_authenticated/settings.agent-prompt'
import { Route as AuthenticatedSettingsConnectionsRouteImport } from './routes/_authenticated/settings.connections'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReviewRoute = AuthenticatedReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTeamRoute = AuthenticatedTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTestRecordRoute = AuthenticatedTestRecordRouteImport.update({
  id: '/test-record',
  path: '/test-record',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTestingRoute = AuthenticatedTestingRouteImport.update({
  id: '/testing',
  path: '/testing',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedCampaignsIndexRoute =
  AuthenticatedCampaignsIndexRouteImport.update({
    id: '/campaigns/',
    path: '/campaigns/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCampaignsCampaignIdRoute =
  AuthenticatedCampaignsCampaignIdRouteImport.update({
    id: '/campaigns/$campaignId',
    path: '/campaigns/$campaignId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCampaignsNewRoute =
  AuthenticatedCampaignsNewRouteImport.update({
    id: '/campaigns/new',
    path: '/campaigns/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSellersSfRecordIdRoute =
  AuthenticatedSellersSfRecordIdRouteImport.update({
    id: '/sellers/$sfRecordId',
    path: '/sellers/$sfRecordId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsAgentPromptRoute =
  AuthenticatedSettingsAgentPromptRouteImport.update({
    id: '/settings/agent-prompt',
    path: '/settings/agent-prompt',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsConnectionsRoute =
  AuthenticatedSettingsConnectionsRouteImport.update({
    id: '/settings/connections',
    path: '/settings/connections',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/sign-in': typeof SignInRoute
  '/review': typeof AuthenticatedReviewRoute
  '/team': typeof AuthenticatedTeamRoute
  '/test-record': typeof AuthenticatedTestRecordRoute
  '/testing': typeof AuthenticatedTestingRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/campaigns/$campaignId': typeof AuthenticatedCampaignsCampaignIdRoute
  '/campaigns/new': typeof AuthenticatedCampaignsNewRoute
  '/sellers/$sfRecordId': typeof AuthenticatedSellersSfRecordIdRoute
  '/settings/agent-prompt': typeof AuthenticatedSettingsAgentPromptRoute
  '/settings/connections': typeof AuthenticatedSettingsConnectionsRoute
  '/campaigns/': typeof AuthenticatedCampaignsIndexRoute
}
export interface FileRoutesByTo {
  '/sign-in': typeof SignInRoute
  '/review': typeof AuthenticatedReviewRoute
  '/team': typeof AuthenticatedTeamRoute
  '/test-record': typeof AuthenticatedTestRecordRoute
  '/testing': typeof AuthenticatedTestingRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/': typeof AuthenticatedIndexRoute
  '/campaigns/$campaignId': typeof AuthenticatedCampaignsCampaignIdRoute
  '/campaigns/new': typeof AuthenticatedCampaignsNewRoute
  '/sellers/$sfRecordId': typeof AuthenticatedSellersSfRecordIdRoute
  '/settings/agent-prompt': typeof AuthenticatedSettingsAgentPromptRoute
  '/settings/connections': typeof AuthenticatedSettingsConnectionsRoute
  '/campaigns': typeof AuthenticatedCampaignsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/_authenticated/review': typeof AuthenticatedReviewRoute
  '/_authenticated/team': typeof AuthenticatedTeamRoute
  '/_authenticated/test-record': typeof AuthenticatedTestRecordRoute
  '/_authenticated/testing': typeof AuthenticatedTestingRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/campaigns/$campaignId': typeof AuthenticatedCampaignsCampaignIdRoute
  '/_authenticated/campaigns/new': typeof AuthenticatedCampaignsNewRoute
  '/_authenticated/sellers/$sfRecordId': typeof AuthenticatedSellersSfRecordIdRoute
  '/_authenticated/settings/agent-prompt': typeof AuthenticatedSettingsAgentPromptRoute
  '/_authenticated/settings/connections': typeof AuthenticatedSettingsConnectionsRoute
  '/_authenticated/campaigns/': typeof AuthenticatedCampaignsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/review'
    | '/team'
    | '/test-record'
    | '/testing'
    | '/auth/callback'
    | '/campaigns/$campaignId'
    | '/campaigns/new'
    | '/sellers/$sfRecordId'
    | '/settings/agent-prompt'
    | '/settings/connections'
    | '/campaigns/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/sign-in'
    | '/review'
    | '/team'
    | '/test-record'
    | '/testing'
    | '/auth/callback'
    | '/'
    | '/campaigns/$campaignId'
    | '/campaigns/new'
    | '/sellers/$sfRecordId'
    | '/settings/agent-prompt'
    | '/settings/connections'
    | '/campaigns'
  id:
    | '__root__'
    | '/_authenticated'
    | '/sign-in'
    | '/_authenticated/review'
    | '/_authenticated/team'
    | '/_authenticated/test-record'
    | '/_authenticated/testing'
    | '/auth/callback'
    | '/_authenticated/'
    | '/_authenticated/campaigns/$campaignId'
    | '/_authenticated/campaigns/new'
    | '/_authenticated/sellers/$sfRecordId'
    | '/_authenticated/settings/agent-prompt'
    | '/_authenticated/settings/connections'
    | '/_authenticated/campaigns/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  SignInRoute: typeof SignInRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/review': {
      id: '/_authenticated/review'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof AuthenticatedReviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/team': {
      id: '/_authenticated/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AuthenticatedTeamRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/test-record': {
      id: '/_authenticated/test-record'
      path: '/test-record'
      fullPath: '/test-record'
      preLoaderRoute: typeof AuthenticatedTestRecordRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/testing': {
      id: '/_authenticated/testing'
      path: '/testing'
      fullPath: '/testing'
      preLoaderRoute: typeof AuthenticatedTestingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/campaigns/': {
      id: '/_authenticated/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof AuthenticatedCampaignsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/campaigns/$campaignId': {
      id: '/_authenticated/campaigns/$campaignId'
      path: '/campaigns/$campaignId'
      fullPath: '/campaigns/$campaignId'
      preLoaderRoute: typeof AuthenticatedCampaignsCampaignIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/campaigns/new': {
      id: '/_authenticated/campaigns/new'
      path: '/campaigns/new'
      fullPath: '/campaigns/new'
      preLoaderRoute: typeof AuthenticatedCampaignsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sellers/$sfRecordId': {
      id: '/_authenticated/sellers/$sfRecordId'
      path: '/sellers/$sfRecordId'
      fullPath: '/sellers/$sfRecordId'
      preLoaderRoute: typeof AuthenticatedSellersSfRecordIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/agent-prompt': {
      id: '/_authenticated/settings/agent-prompt'
      path: '/settings/agent-prompt'
      fullPath: '/settings/agent-prompt'
      preLoaderRoute: typeof AuthenticatedSettingsAgentPromptRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/connections': {
      id: '/_authenticated/settings/connections'
      path: '/settings/connections'
      fullPath: '/settings/connections'
      preLoaderRoute: typeof AuthenticatedSettingsConnectionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedReviewRoute: typeof AuthenticatedReviewRoute
  AuthenticatedTeamRoute: typeof AuthenticatedTeamRoute
  AuthenticatedTestRecordRoute: typeof AuthenticatedTestRecordRoute
  AuthenticatedTestingRoute: typeof AuthenticatedTestingRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedCampaignsCampaignIdRoute: typeof AuthenticatedCampaignsCampaignIdRoute
  AuthenticatedCampaignsNewRoute: typeof AuthenticatedCampaignsNewRoute
  AuthenticatedSellersSfRecordIdRoute: typeof AuthenticatedSellersSfRecordIdRoute
  AuthenticatedSettingsAgentPromptRoute: typeof AuthenticatedSettingsAgentPromptRoute
  AuthenticatedSettingsConnectionsRoute: typeof AuthenticatedSettingsConnectionsRoute
  AuthenticatedCampaignsIndexRoute: typeof AuthenticatedCampaignsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedReviewRoute: AuthenticatedReviewRoute,
  AuthenticatedTeamRoute: AuthenticatedTeamRoute,
  AuthenticatedTestRecordRoute: AuthenticatedTestRecordRoute,
  AuthenticatedTestingRoute: AuthenticatedTestingRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedCampaignsCampaignIdRoute: AuthenticatedCampaignsCampaignIdRoute,
  AuthenticatedCampaignsNewRoute: AuthenticatedCampaignsNewRoute,
  AuthenticatedSellersSfRecordIdRoute: AuthenticatedSellersSfRecordIdRoute,
  AuthenticatedSettingsAgentPromptRoute: AuthenticatedSettingsAgentPromptRoute,
  AuthenticatedSettingsConnectionsRoute: AuthenticatedSettingsConnectionsRoute,
  AuthenticatedCampaignsIndexRoute: AuthenticatedCampaignsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  SignInRoute: SignInRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
